import React, { useState, useCallback } from 'react';
import { Button } from 'react-bootstrap';
import { createUseStyles } from "react-jss";
import { useHistory } from 'react-router';
import { Product } from "../types";
import BackgroundImage from './BackgroundImage';
import Text from './Text';

export interface NavBarTrendingProductProps {
    product: Product;
}
const NavBarTrendingProduct: React.FC<NavBarTrendingProductProps> = ({ product }) => {
    const classes = useStyles();
    const history = useHistory();

    const goToLink = useCallback((e, link) => {
        e.preventDefault();
        history.push(link)
    }, []);

    const hasDiscount = product.originalPrice !== product.discountedPrice && product.discountedPrice != 0;


    const { currencyCode } = product.currency;


    return (
        <div className={classes.navProduct} >
            <a href={product.uniqueName} className={classes.navProductImgDiv} onClick={e => goToLink(e, product.uniqueName)}>
                <BackgroundImage height="100%" src={product.photo} className={classes.navProductImg}></BackgroundImage>
            </a>
            <div className={classes.navProductInfoDiv} >
                <a href={product.uniqueName} onClick={e => goToLink(e, product.uniqueName)}>
                    <Text bold className={classes.titleProduct}>{product.name}</Text>
                </a>
                <div className={classes.navProductDetails}>
                    <a href={product.business.uniqueName} onClick={e => goToLink(e, product.business.uniqueName)}>
                        <Text className={classes.navProductBusinessName}>{product.business.name}</Text>
                    </a>
                    <Text className={classes.navProductPrice} bold>
                        {hasDiscount ? product.discountedPrice : product.originalPrice}{' '}
                        {product.originalPrice ? currencyCode : null}
                    </Text>

                    {hasDiscount ? <Text className={classes.navProductPriceDiscount}>
                        {product.originalPrice} {currencyCode}
                    </Text> : null}
                </div>
            </div>
        </div>
    )
}

const useStyles = createUseStyles({
    navProduct: {
        marginBottom: "10px",
        width: "100%",
        display: "flex",
    },
    navProductImgDiv: {
        width: "50px",
        height: "50px"
    },
    navProductImg: {

        width: "50px",
        height: "50px",
        backgroundSize: "cover",
        backgroundPosition: "center",
    },
    navProductInfoDiv: {
        padding: "0px 10px"
    },
    titleProduct: {
        fontSize: "13px",
        cursor: "pointer"
    },
    navProductDetails: {
        display: "flex",
        alignItems: "center"
    },
    navProductBusinessName: {
        width: "fit-content",
        border: "1px solid #8D8D8D",
        padding: "0px 8px",
        fontSize: "12px",
        fontWeight: "100",
        height: "20px",
        borderRadius: "4px"
    },
    navProductPrice: {
        margin: "0px 5px",
        fontSize: "18px"
    },
    navProductPriceDiscount: {
        fontSize: "15px",
        textDecoration: "line-through",
        color: "#522583 !important"
    }

});

export default NavBarTrendingProduct;
